module.exports = __webpack_public_path__ + "static/media/dropdownDownArrow.8bcfd998.svg";